/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import { useSimpliCity } from "cms/hooks/use-simplicity";
import { Menu } from "components/header/primary_menu/menu";
import { MenuItem } from "components/header/primary_menu/menu_item";

const HeaderMenu = () => {

    const { menu, side } = useSimpliCity();

    return (
        <div className="primary-menu-content-menu simplicity-menu-wrapper menu-level-1">
            <Menu level={1} side={side} position={1} id="simplicity-menu-level1">
                {menu.map((item, index) => (
                    <MenuItem
                        parent_postion={1}
                        position={index}
                        level={0}
                        side={index < 2 ? "right" : "left"}
                        size={menu.length}
                        title={item.title}
                        url={item.url}
                        nav_children={item.children}
                        key={item.url}
                    />
                ))}
            </Menu>
        </div>
    );
};

export { HeaderMenu };
